export class OrganisationRoleConstants {
  public static readonly OWNER = "Owner";

  public static readonly ADMIN = "Admin";

  public static readonly STAFF = "Staff";

  public static readonly VVB_MANAGER = "Manager";

  public static readonly VVB_AUDITOR = "Auditor";
}

export type UserRole =
  | typeof OrganisationRoleConstants.OWNER
  | typeof OrganisationRoleConstants.ADMIN
  | typeof OrganisationRoleConstants.STAFF
  | typeof OrganisationRoleConstants.VVB_AUDITOR
  | typeof OrganisationRoleConstants.VVB_MANAGER;
